<template>
  <div class="background" :class="{'long':long}">
  <div class="chart-container" :class="{'longCont':long}">
    <div v-html="styleText"></div>

    <div @click="printPdf" class="noPrint">{{$t('print')}}</div>
    <div class="Hcp-main-header">
      <div class="main-header-left">
        <img src="../../assets/LOGO.png">
      </div>
      <div class="main-header-right">
        <p>{{$t('EventReport')}} ({{$t('By Category')}})</p>
        <p>{{$t('period')}}: {{timeRange}}</p>
      </div>
    </div>
    <table class="status-table1">
      <tr>
        <td class="td4">{{$t('uername')}}: {{statics.username}}</td>
        <td class="td4">{{$t('fullName')}}: {{statics.name}}</td>
        <td class="td4">{{$t('disType')}}: {{statics.medical_history}}</td>
        <td>{{$t('HbA1c')}}: {{hb1c}}</td>
      </tr>
    </table>

    <div class="small-hr"></div>

    <p style="margin-left:29px;margin-top: 20px;">{{$t('BG Summary')}}</p>
    <div v-for="(base, p) in pagePosBG">

      <div v-if="p>=1">
        <div class="page-break"></div>
        <div class="page-starter"></div>
      </div>

      <table class="events-table" style="margin-top: 5px;" :id='"bg"+base'>
        <tr>
          <td class="td5" width="95px">{{$t('date')}}</td>
          <td v-for="i in hours"  class="td2">{{i}}</td><td class="td5">Avg/#</td>
        </tr>
        <tr v-for="day in whichDate.slice(base, base+base+perPageBG[p])">
          <td class="td1 td4">{{day}}</td>
          <td v-for="i in 24" class="td4"></td><td class="td1 td2"></td>
        </tr>
      </table>
    </div>

    <div v-if="endPageBG.show">
      <div class="page-break"></div>
      <div class="page-starter"></div>
    </div>

    <p style="margin-left:29px;margin-top: 20px;">{{$t('Carbs Summary')}}</p>

    <div v-for="(base, p) in pagePosCarb">

      <div v-if="p>=1">
        <div class="page-break"></div>
        <div class="page-starter"></div>
      </div>

      <table class="events-table" style="margin-top: 5px;" :id='"carb"+base'>
        <tr>
          <td class="td5" width="95px">{{$t('date')}}</td>
          <td v-for="i in hours"  class="td2">{{i}}</td><td class="td5">Avg/#</td>
        </tr>
        <tr v-for="day in whichDate.slice(base, base+perPageCarb[p])">
          <td class="td1 td4">{{day}}</td>
          <td v-for="i in 24" class="td4"></td><td class="td1 td2"></td>
        </tr>
      </table>
    </div>



    <div v-if="endPageCarb.show">
      <div class="page-break"></div>
      <div class="page-starter"></div>
    </div>

    <p style="margin-left:29px;margin-top: 20px;">{{$t('Injection Summary')}}</p>
    <div v-for="(base, p) in pagePosInj">

      <div v-if="p>=1">
        <div class="page-break"></div>
        <div class="page-starter"></div>
      </div>

      <table class="events-table" style="margin-top: 5px;" :id='"bol"+base'>
        <tr>
          <td class="td5" width="95px">{{$t('date')}}</td>
          <td v-for="i in hours"  class="td2">{{i}}</td><td class="td5">Avg/#</td>
        </tr>
        <tr v-for="day in whichDate.slice(base, base+perPageInj[p])">
          <td class="td1 td4">{{day}}</td>
          <td v-for="i in 24" class="td4"></td><td class="td1 td2"></td>
        </tr>
      </table>
    </div>

    <div v-if="endPageInj.show">
      <div class="page-break"></div>
      <div class="page-starter"></div>
    </div>


    <p style="margin-left:29px;margin-top: 20px;">{{$t('Exercise Summary')}}</p>
    <div v-for="(base, p) in pagePosExer">

      <div v-if="p>=1">
        <div class="page-break"></div>
        <div class="page-starter"></div>
      </div>

      <table class="events-table" style="margin-top: 5px;" :id='"exer"+base'>
        <tr>
          <td class="td5" width="95px">{{$t('date')}}</td>
          <td v-for="i in hours"  class="td2">{{i}}</td><td class="td5">Avg/#</td>
        </tr>
        <tr v-for="day in whichDate.slice(base, base+perPageExer[p])">
          <td class="td1 td4">{{day}}</td>
          <td v-for="i in 24" class="td4"></td><td class="td1 td2"></td>
        </tr>
      </table>
    </div>

    <div v-if="endPageExer.show">
      <div class="page-break"></div>
      <div class="page-starter"></div>
    </div>


    <div class="statics">
      <p class="custom">{{$t('static')}}</p>
      <table class="statics-table">
        <tr>
          <td class="td1">{{$t('type')}}</td><td class="td1">{{$t('Avg')}}</td><td class="td1">{{$t('SD')}}</td>
          <td class="td1">{{$t('max')}}</td><td class="td1">{{$t('min')}}</td><td class="td2">{{$t('#')}}</td>
        </tr>
        <tr>
          <td class="td1">{{$t('BG1')}}</td><td class="td1">{{bgstat[0]}}</td> <td class="td1">{{bgstat[1]}}</td>
          <td class="td1">{{bgstat[2]}}</td> <td class="td1">{{bgstat[3]}}</td><td class="td2">{{bgstat[4]}}</td>
        </tr>
        <tr>
          <td class="td1">{{$t('carbs')}}</td><td class="td1">{{carbstat[0]}}</td> <td class="td1">{{carbstat[1]}}</td>
          <td class="td1">{{carbstat[2]}}</td> <td class="td1">{{carbstat[3]}}</td><td class="td2">{{carbstat[4]}}</td>
        </tr>
        <tr>
          <td class="td1">{{$t('Injection')}}</td><td class="td1">{{bolstat[0]}}</td> <td class="td1">{{bolstat[1]}}</td>
          <td class="td1">{{bolstat[2]}}</td> <td class="td1">{{bolstat[3]}}</td><td class="td2">{{bolstat[4]}}</td>
        </tr>
        <tr>
          <td class="td3">{{$t('exercise')}}</td><td class="td3">{{exerstat[0]}}</td> <td class="td3">{{exerstat[1]}}</td>
          <td class="td3">{{exerstat[2]}}</td> <td class="td3">{{exerstat[3]}}</td><td >{{exerstat[4]}}</td>
        </tr>
      </table>
    </div>

    <div class="page-end"></div>
  </div>
  </div>
</template>

<script>
  import * as echarts from 'echarts'
  import auth from '../../auth/auth'
      import format from '@/lib/format'
  import B64 from '../../auth/base64'
  export default{
    data() {
      return {
        whichDate:[],
        hours:['00:00','01:00','02:00','03:00','04:00','05:00','06:00','07:00','08:00','09:00','10:00',
          '11:00','12:00','13:00','14:00','15:00','16:00','17:00','18:00','19:00','20:00','21:00','22:00','23:00'],
        uid: 0, st: 0, et: 0,timeRange:'',long:false,isEn:false,isMg:"",ts:[],
        styleText:'<style type="text/css" media="print">@page{size:landscape;margin:0;}</style>',
        statics: {}, hb1c: ['--'],
        bgstat: [],
        carbstat: [],
        bolstat:[],
        exerstat: {"day":
          {
            "avg": "--",
            "max": "--",
            "min": "--",
            "num": "--",
            "sd": "--",
            "total": "--"
          },
        },
        pagePosBG:[],perPageBG:[],endPageBG:{show:false},
        pagePosCarb:[],perPageCarb:[],endPageCarb:{show:false},
        pagePosInj:[],perPageInj:[],endPageInj:{show:false},
        pagePosExer:[],perPageExer:[],endPageExer:{show:false},
      }
    },

    methods:{
      getStatics(){
        if(sessionStorage.getItem('userType')!=='P'){
          this.uid = parseInt(sessionStorage.getItem('patientId'));
        }else{
          this.uid = parseInt(sessionStorage.getItem('uid'));
        }
        this.et = parseInt(sessionStorage.getItem('qet6'));
        this.st= parseInt(sessionStorage.getItem('qst6'));
        this.timeRange = format.formatterDate2(this.st)+' - '+ format.formatterDate2(this.et);
        this.ts =auth.getTs(this.st,this.et);
        this.getDate();
        let param = {
          ts:this.ts,
          tz:parseInt(sessionStorage.getItem('tz')),
          gu:(this.isMg)?'mg/dL':'mmol/L',
        };
        param = B64.base64encode(JSON.stringify(param));
        this.$http.get('api/v2.1/report/'+this.uid+'/data/erc',{params:{param}}).then(function (res) {
          let err =res.body.error;
          if(err === 0){
              console.log(res.data);
            let data =  res.data.data;
            data.medical_history = (data.medical_history )?this.$t(data.medical_history):"--";
            if(data.medical_history){
             data.medical_history = data.medical_history.split(',')[0];
            }
            this.statics = data;
            this.hb1c = (data.hba1c)?data.hba1c:this.hb1c;
            this.bgstat = (data.bg_event_stat)?data.bg_event_stat:this.bgstat;
            this.carbstat = (data.carb_event_stat)?data.carb_event_stat:this.carbstat;
            this.bolstat = (data.bolus_event_stat)?data.bolus_event_stat:this.bolstat;
            this.exerstat = (data.exercise_event_stat)?data.exercise_event_stat:this.exerstat;
            let that =this;
            data.bg_event.map(function (e,i) {
              that.makeData(e,i,'bg')
            });
            data.carb_event.map(function (e,i) {
              that.makeData(e,i,'carb')
            });
            data.bolus_event.map(function (e,i) {
              that.makeData(e,i,'bol')
            });
            data.exercise_event.map(function (e,i) {
              that.makeData(e,i,'exer')
            })
          }
        },function(err){
          let tip =  this.$t('tryAgain');
          this.$message.error(tip);
        })
      },
      getDate(){
        let dayNum = parseInt((this.et-this.st)/86400)+1;
        for(let i=0;i<dayNum;i++){
           let t = this.st+i*86400;
           this.whichDate[i] = format.formatterDate2(t)+','+format.formatterDay(this,t);
        }
        if(dayNum>8){
            this.long = true;
        }
        console.log("whichDate:", this.whichDate);
        let PER_PAGE1=26;
        let PER_PAGE2=32;

        let totalRow=(dayNum)*4;
        let itemRow=(dayNum);

        console.log("dayNum:", dayNum, totalRow);

        let rowIndex=0;
        let itemIndex=0;
        let currentItem=0;
        let currentPerPage=PER_PAGE1;
        let currentRowIndex=0;
        let activePagePos;
        let activePerPage;
        let activeEndPage;
        let isFirstPage=true;
        let usedPageRow=0;
        let pageIndex=0;
        let pageLeftRow=0;
        let titleUsedRow=0;

        while (currentItem<4 && pageIndex<100) {

          while (currentRowIndex<itemRow && pageIndex<100) {   // 0<10

            if (0==pageIndex) {
              currentPerPage=PER_PAGE1;
            } else {
              currentPerPage=PER_PAGE2;
            }

            pageLeftRow = currentPerPage - usedPageRow - titleUsedRow;
            //pageLeftRow -= titleUsedRow;

            console.log("pageLeftRow:", pageIndex, currentItem, currentPerPage, usedPageRow, titleUsedRow, pageLeftRow,
               currentRowIndex, itemRow);
            if (pageLeftRow <=0 ) {   // 当前页不够, 另起一页.
              //
              let preItem=currentItem-1;
              if (preItem>=0) {
                if (0==preItem) {
                  this.endPageBG.show=true;
                } else if (1==preItem) {
                  this.endPageCarb.show=true;
                } else if (2==preItem) {
                  this.endPageInj.show=true;
                } else if (3==preItem) {
                  this.endPageExer.show=true;
                }
              }
              pageIndex += 1;
              usedPageRow = 0;
              titleUsedRow = 0;
              break;
            }

            if (0==currentItem) {
              this.pagePosBG.push(currentRowIndex);
              this.perPageBG.push(pageLeftRow);
              //activePagePos=this.pagePosBG;
              //activePerPage=this.perPageBG;

            } else if (1==currentItem) {
              this.pagePosCarb.push(currentRowIndex);
              this.perPageCarb.push(pageLeftRow);
              //activePagePos=this.pagePosCarb;
              //activePerPage=this.perPageCarb;
            } else if (2==currentItem) {
              this.pagePosInj.push(currentRowIndex);
              this.perPageInj.push(pageLeftRow);
              //activePagePos=this.pagePosInj;
              //activePerPage=this.perPageInj;
            } else if (3==currentItem) {
              this.pagePosExer.push(currentRowIndex);
              this.perPageExer.push(pageLeftRow);
              //activePagePos=this.pagePosExer;
              //activePerPage=this.perPageExer;
            }
            //activePagePos.push(currentRowIndex);
            //activePerPage.push(currentPerPage);

            //
            //pageIndex += 1;

            // itemRow-currentRowIndex 表示当前项的数据还有多少行需要安排
            // pageLeftRow 表示当前页还有多少空余地方可以使用。
            console.log('currentRowIndex:', currentItem, pageIndex, currentRowIndex, pageLeftRow, usedPageRow,
              itemRow-currentRowIndex);
            if (pageLeftRow>(itemRow-currentRowIndex)) {   // 当前页可以放下当前项的数据， 不用换页， 直接换项
              currentItem++;
              usedPageRow += (itemRow-currentRowIndex);
              currentRowIndex=0;
              titleUsedRow += 2;

              console.log('branch1:', usedPageRow, pageIndex, currentItem);
              break;  // 跳出内层的 while 循环。

            } else if (pageLeftRow < (itemRow-currentRowIndex)) {  // 当前页可以放不下当前项的数据， 需要换页， 数据项不换
              pageIndex += 1;
              currentRowIndex += pageLeftRow;
              usedPageRow = 0;
              titleUsedRow=0;   // 换页时置零。

              console.log('branch2:', currentRowIndex, pageIndex, currentItem);
            } else if (pageLeftRow == (itemRow-currentRowIndex)) {   // 刚好放下， 换项也换页。

              // 设置数据项间的换页标志。
              if (0==currentItem) {
                this.endPageBG.show=true;
              } else if (1==currentItem) {
                this.endPageCarb.show=true;
              } else if (2==currentItem) {
                this.endPageInj.show=true;
              } else if (3==currentItem) {
                this.endPageExer.show=true;
              }

              pageIndex += 1;
              usedPageRow = 0;
              currentItem++;
              currentRowIndex=0;
              titleUsedRow=0;   // 换页时置零。

              console.log('branch3:', usedPageRow, pageIndex, currentItem);

              break;  // 跳出内层的 while 循环。

            }
            /*
            if (currentRowIndex + currentPerPage>itemRow) {   //当前页可以装下当前种类的数据。 就要换一种新的数据。
              currentItem++;
              currentRowIndex=0;

              currentPerPage = currentRowIndex + currentPerPage - itemRow;
              //if (isFirstPage) {
              //  isFirstPage = false;
              //}

              break;

            //} else if (currentRowIndex + currentPerPage==itemRow){

            }else {
              currentRowIndex += currentPerPage;
            }*/
          }
        }

        console.log("pagePosBG:", this.pagePosBG);
        console.log("perPageBG:", this.perPageBG);
        console.log("endPageBG:", this.endPageBG);

        console.log("pagePosCarb:", this.pagePosCarb);
        console.log("perPageCarb:", this.perPageCarb);
        console.log("endPageCarb:", this.endPageCarb);

        console.log("pagePosInj:", this.pagePosInj);
        console.log("perPageInj:", this.perPageInj);
        console.log("endPageInj:", this.endPageInj);

        console.log("pagePosExer:", this.pagePosExer);
        console.log("perPageExer:", this.perPageExer);
        console.log("endPageExer:", this.endPageExer);

        //for (let i=0; i<4; i++) {
          //while (rowIndex<totalRow) {
            //page
          //}
        //}
      },
      makeData(val,i,id){
        let tempPagePos=[];
        let tempPerPage=[];
        if ('bg'==id) {
          tempPagePos=this.pagePosBG;
          tempPerPage=this.perPageBG;
        } else if ('carb'==id) {
          tempPagePos=this.pagePosCarb;
          tempPerPage=this.perPageCarb;
        } else if ('bol'==id) {
          tempPagePos=this.pagePosInj;
          tempPerPage=this.perPageInj;
        } else if ('exer'==id) {
          tempPagePos=this.pagePosExer;
          tempPerPage=this.perPageExer;
        }
        //console.log("makeData:", id, tempPagePos, );
        //for (let p=0; p<tempPagePos.length; p++) {
        //}
        let p=0;
        for (p=0; p<tempPagePos.length; p++) {
          if (i<tempPagePos[p]) {
            break;
          }
        }

        console.log('tempPerPage:', tempPagePos);
        console.log('makeData:', id, i, p);

        id = id+tempPagePos[p-1];
        i = i - tempPagePos[p-1];
        console.log('makeData.2:', id, i);

        const table = document.getElementById(id);
        const tr = table.getElementsByTagName('tr')[i+1];

        const td0 =tr.getElementsByTagName('td')[0];
        let day = format.formatterDate9(this.ts[i][0]);
        val.day = day[2]+'/'+day[1]+'/'+day[0];
        let day1 = format.formatterDay(this,this.ts[i][0]);
        //td0.innerHTML = val.day+', '+day1;

        const h = 'hour';
        if(val.no_data){
          const td =tr.getElementsByTagName('td');
          let tip1 = this.$t('No1');
          let tip2 = this.$t('data1');
          td[1].innerHTML = tip1;
          td[1].style.textAlign = 'right';
          td[2].innerHTML = tip2;
          td[2].style.textAlign = 'left';
        }else{
          for(let item in val){
            if(item.indexOf(h)>=0){
              let j = parseInt(item.replace(/[^0-9]/ig,""));
              const td =tr.getElementsByTagName('td')[j+1];
              td.innerHTML = val[item]
            }else{
              const td =tr.getElementsByTagName('td')[25];
              td.innerHTML =val.total;
            }
          }
        }
      },
      printPdf(){
        auth.print_page();
      },
    },
    mounted: function () {
      self.document.title = this.$t('EventReport');
      let lang = sessionStorage.getItem('language');
      this.isEn = (lang!=='zh'&&lang !=='hk')?true:false;
      this.isMg = (localStorage.getItem('unit')==='mg')?true:false;
      this.getStatics();
      let first = parseInt(sessionStorage.getItem('qFirst7'));
      if(first===1){
        auth.checkPrint(this,8,7);
      }
    },
  }
</script>
<style scoped meadia="print">
  @page{
    *size:auto;
    *size:portrait;
    size:landscape;
    margin: 0;
  }
  .background{
    padding-top: 5mm;
    width: 100%;
    *min-height: 307mm;
    background: #ccc;
  }
  .background .noPrint{
    float: left;
    border-radius:100px;
    background: #fff;
    border: 1px solid #a3a3a3;
    outline: none;
    margin-top:4px;
    width:90px;
    height:26px;
    line-height: 28px;
    cursor: pointer;
    margin-left:-140px;
    font-size: 13px;
    text-align: center;
  }
  @media print {
    .background .noPrint{
      display: none;
    }
  }
  .chart-container {
    width:297mm;
    *height:307mm;
    font-family:SFUIText-Regular;
    font-size:12px;
    color:#282828;
    letter-spacing:-0.34px;
    background: #fff;
    margin:0 auto;
    padding-left: 20px;
    padding-right: 20px;
  }
  .Hcp-main-header{
    width:97%;
    height:40px;
    margin:0 auto;
    font-family:SFUIText-Regular;
    font-size:12px;
    color:#282828;
    padding-top: 10px;
  }
  .long{
    *min-height: 594mm;
  }
  .longCont{
    *height: 594mm;
  }
  .main-header-left{
    float: left;
  }
  .main-header-left img{
    height:45px;
    width: 100px;
  }
  .main-header-right{
    float: right;
    text-align: right;
    padding-top: 10px;
    margin-right: 15px;
  }
  .main-header-right p{
    font-size:12px;
    margin-bottom: 5px;
    letter-spacing:-0.29px;
    font-family:SFUIText-Regular;
    color:#282828;
  }

  .status-table1{
    width: 94%;
    margin:20px auto 16px;
    border:1px solid #747474;
    font-family:SFUIText-Regular;
    border-collapse: collapse;
    text-align:left;
    table-layout: fixed;
  }
  .status-table1 td{
    padding-left: 10px;
    height:20px;
  }
  .status-table1 .td4{
    border-right:1px solid rgba(116,116,116,0.34);
  }
  .small-hr{
    background:#3b3b3b;
    width:94%;
    height:1px;
    margin:10px auto 16px;
    border:none;
  }

  .events-table{
    width: 94%;
    margin:0 auto;
    font-family:SFUIText-Regular;
    border-collapse: collapse;
    text-align:center;
    table-layout: fixed;
  }
  .events-table td{
    height: 18px;
    font-size: 12px;
    -webkit-transform: scale(0.8);
    -moz-transform: scale(0.8);
    -ms-transform: scale(0.8);
    -o-transform: scale(0.8);
    transform: scale(0.8);
  }
  .events-table .td1{
    border-left:1px solid rgba(116,116,116,0.34);
    border-right:1px solid rgba(116,116,116,0.34);
  }
  .events-table .td2{
    border-bottom:1px solid rgba(116,116,116,0.34);
    border-top:1px solid rgba(116,116,116,0.34);
    font-size: 12px;
    -webkit-transform: scale(0.65);
    -moz-transform: scale(0.65);
    -ms-transform: scale(0.65);
    -o-transform: scale(0.65);
    transform: scale(0.65);
    color:#282828;
  }
  .events-table .td3{
    border-right:1px solid rgba(116,116,116,0.34);
  }
  .events-table .td4{
    border-bottom:1px solid rgba(116,116,116,0.34);
  }
  .events-table .td5{
    border:1px solid rgba(116,116,116,0.34);
  }

  .statics{
    margin-top: 25px;
    margin-bottom: 17px;
  }
  .statics p{
    margin-left: 3%;
    font-family:SFUIText-Regular;
    font-size:13px;
    color:#282828;
    letter-spacing:-0.27px;
    text-align:left;
    padding-left: 3px;
  }
  .statics-table{
    width: 94%;
    margin:6px auto 0;
    border:1px solid #747474;
    font-family:SFUIText-Regular;
    border-collapse: collapse;
    text-align:center;
    table-layout: fixed;
  }
  .statics-table td{
    height:20px;
  }
  .statics-table .td1{
    border-bottom:1px solid rgba(116,116,116,0.34);
    border-right:1px solid rgba(116,116,116,0.34);
  }
  .statics-table .td2{
    border-bottom:1px solid rgba(116,116,116,0.34);
  }
  .statics-table .td3{
    border-right:1px solid rgba(116,116,116,0.34);
  }

  .page-break {
    page-break-before: always;
  }

  .page-starter {
    height:10mm;
  }

  .page-end {
    clear: both;
    height:2mm;
  }
</style>



// WEBPACK FOOTER //
// quickPrint7.vue?6ba3135e